import { where } from 'firebase/firestore'

import FirestoreService from '../../firestoreService'

import { getConvertedData } from '../../../models/interface.helper'

import { RecipientModel } from '../../../models/recipients/recipients'

import { IRecipientInterface } from '../../../models/recipients/recipients.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

const getByRecipientRegistrationId = async (registrationId: string, recipientId: string) => {
  const recipientSnaps = await FirestoreService.filterItems(COLLECTIONS.RECIPIENT.NAME, [
    where(COLLECTIONS.RECIPIENT.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationId),
    where(COLLECTIONS.RECIPIENT.FIELDS.RECIPIENT_ID.KEY, '==', recipientId),
  ])
  if (recipientSnaps.size) {
    return getConvertedData(RecipientModel.fromFirestoreDoc(recipientSnaps.docs[0]).toObject())
  }
}

const getByRecipientsByEvent = async (eventId: string, registrarId: string) => {
  let recipients: IRecipientInterface[] = []

  const recipientSnapShots = await FirestoreService.filterItems(COLLECTIONS.RECIPIENT.NAME, [
    where(COLLECTIONS.RECIPIENT.FIELDS.EVENT_ID.KEY, '==', eventId),
    where(COLLECTIONS.RECIPIENT.FIELDS.USER_ID.KEY, '==', registrarId),
  ])

  recipientSnapShots.forEach((currDoc) => {
    recipients.push(getConvertedData(RecipientModel.fromFirestoreDoc(currDoc).toObject()))
  })

  return recipients
}

const RecipientsService = {
  getByRecipientRegistrationId,
  getByRecipientsByEvent,
}

export default RecipientsService
